module.exports = __webpack_public_path__ + "static/media/ic_report.1d7abd62.png";